import axios from 'axios';

// MOCK INTEGRATION FOR UI DEVELOPMENT - PARTIALLY REPLACED WITH REAL BACKEND

export const UploadFile = async ({ file }) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            // Create a fake URL for the uploaded file - kept for preview purposes
            const url = URL.createObjectURL(file);
            resolve({ file_url: url });
        }, 500); // Reduced delay
    });
};

export const InvokeLLM = async ({ prompt, file, response_json_schema }) => {
    try {
        console.log("Invoking Real AI Backend...", { prompt, file });

        const token = localStorage.getItem('token');
        // Fallback to hardcoded URL to ensure stability if env var is missing
        const baseUrl = process.env.REACT_APP_API_URL || 'https://api.azalega-academy.com/api/v1';

        let url;
        let requestData;
        let headers = {
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        };

        if (file) {
            // Image Analysis Request
            url = 'https://api.azalega-academy.com/api/v1/ai/analyze-chart';
            const formData = new FormData();
            formData.append('prompt', prompt);
            formData.append('image', file);
            formData.append('schema', JSON.stringify(response_json_schema));

            requestData = formData;
            headers['Content-Type'] = 'multipart/form-data';
        } else {
            // Text Chat Request
            url = 'https://api.azalega-academy.com/api/v1/ai/chat';
            requestData = { prompt };
            headers['Content-Type'] = 'application/json';
        }

        const response = await axios.post(url, requestData, { headers });

        console.log("AI Response:", response.data);
        return response.data.data;

    } catch (error) {
        console.error("AI Generation Error:", error);

        // Extract meaningful error message from server response if available
        if (error.response && error.response.data && error.response.data.message) {
            throw new Error(error.response.data.message);
        }

        throw error;
    }
};
